import { ITextSnippetDTO } from '@modeso/types__aumico-lib-annualreport-be';
import { Subject } from 'rxjs';

export interface ITextSnippetDialogData {
    titleLocalizationKey: string | undefined;
    textSnippetData: ITextSnippetDTO | undefined;
    descriptionExistsError: Subject<boolean>;
}
